import React, { useContext } from 'react';
import styled from 'styled-components';
import CommonNotificationSlider from 'ls-common-client/dist/components/NotificationSlider';
import { Context } from '../context/AppContext';

const StyledNotificationSlider = styled(CommonNotificationSlider)`
  span {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const NotificationSlider = ({ ...props }) => {
  const {
    media: { mobile },
  } = useContext(Context);

  return (
    <StyledNotificationSlider
      zIndex={999999}
      duration={5000}
      mode={mobile ? 'mobile' : 'desktop'}
      {...props}
    />
  );
};

export default NotificationSlider;
